import axios from 'axios';

export default {
  state: {
    products: [],
    section_id: false,
    product_total: 0,
    section: {},
    loading: false,
    error: null,
    productsLoaded: false,
    noMoreProducts: false
  },
  mutations: {
    SET_PRODUCTS(state, {products, page}) {
      if (page > 1) {
        state.products = state.products.concat(products.data.items)
      }
      else
        state.products = products.data.items;
      if (state.products.length >= products.data.total)
        state.noMoreProducts = true;
      state.productsLoaded = true; // Устанавливаем флаг, что данные загружены
      state.section = products.data.section;
      state.product_total = products.data.total;
    },
    SET_PRODUCTS_LOADING(state, status) {
      state.productsLoading = status;
    },
    SET_PRODUCTS_ERROR(state, error) {
      state.productsError = error;
    },
    UNSET_PRODUCTS(state) {
      state.productsLoaded = false;
      state.productsLoading = false;
      state.products = [];
      state.product_total = 0;
      state.section = {};
      state.noMoreProducts = false;
    },
  },
  actions: {
    async fetchProducts({ commit, state }, {id, page, sort, filter={}, search='', first=false}) {

      if (id == undefined)
        return;

      if (state.products.length > 0 && state.section_id == id && first) {
        return;
      }

      state.section_id = id;

      if (page == 1)
      commit('UNSET_PRODUCTS');


      try {
        commit('SET_PRODUCTS_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/catalog/elements/'+id+'/', {
          params: {
            page: page,
            filter: filter,
            sort: sort,
            q: search
          }
        });
        if (String(state.section_id) !== String(id)) { return; }
        if (response.data.status != 'success') {
          commit('UNSET_PRODUCTS');
          commit('SET_PRODUCTS_ERROR', 'Ошибка при загрузке.');
        }
        else {
          commit('SET_PRODUCTS', {products: response.data, page: page});
          commit('SET_PRODUCTS_ERROR', null);
        }
      } catch (error) {
        if (String(state.section_id) !== String(id)) { return; }
        commit('SET_PRODUCTS_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching products:', error);
      } finally {
        if (String(state.section_id) === String(id)) { commit('SET_PRODUCTS_LOADING', false); }
      }
    }
  },
  getters: {
    products: state => state.products,
    product_total: state => state.product_total,
    section: state => state.section,
    productsLoading: state => state.productsLoading,
    productsError: state => state.productsError,
    productsLoaded: state => state.productsLoaded,
    noMoreProducts: state => state.noMoreProducts
  }
}